import { render } from "./indexChart.vue?vue&type=template&id=12774e92"
import script from "./indexChart.vue?vue&type=script&lang=js"
export * from "./indexChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__